import 'whatwg-fetch'
import reduce from 'lodash/reduce'
import defaults from 'lodash/defaults'

export const get = (url, options) => {
  const ops = defaults({ method: 'GET' }, options)
  return window.fetch(url, ops)
}

export const post = (url, data) => {
  const formBody = reduce(data, (result, value, key) => {
    const encodedKey = encodeURIComponent(key)
    const encodedValue = encodeURIComponent(value)
    return result.concat(`${encodedKey}=${encodedValue}`)
  }, []).join('&')
  return window.fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formBody
  })
}



// WEBPACK FOOTER //
// ./src/app/api.js